import useSWR from 'swr'
import {camelizeResult} from '~/api/serializer'
import {fetcher} from '../../api/fetcher'

/**
 * SWR-based hook for polling any API endpoint
 * @param {string} url - The API endpoint URL to poll
 * @param {boolean} enabled - Whether polling should be active
 * @param {number} interval - Polling interval in milliseconds (default: 5000)
 * @param {Array} middleware - Array of middleware functions for data transformation (default: [camelizeResult])
 * @returns {Object} Object containing data, loading state, and error state
 */
const usePolling = (
  url,
  enabled = true,
  interval = 5000,
  middleware = [camelizeResult],
) => {
  const {data, isLoading, error} = useSWR(
    enabled && url ? url : null,
    fetcher,
    {
      use: middleware,
      refreshInterval: enabled ? interval : 0,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  )

  return {data, loading: isLoading, error}
}

export default usePolling
